import { INSERT_OPERATION_LOG,
    INSERT_OPERATION_LOG_SUCCESS,
    INSERT_OPERATION_LOG_FAIL,
    SEARCH_UNKNOWN_PACKAGE_DATA,
    SEARCH_UNKNOWN_PACKAGE_DATA_SUCCESS,
    SEARCH_UNKNOWN_PACKAGE_DATA_FAIL,
    RESTORE_TO_STATE,
    RESTORE_TO_STATE_SUCCESS,
    RESTORE_TO_STATE_FAIL,
    OAUTH_TOKEN,
    OAUTH_TOKEN_SUCCESS,
    OAUTH_TOKEN_FAIL } from '../actions/types';

const initialState = {
    insertOperationLogLoading: false,
    insertOperationLog: [],
    insertOperationLogError: false,
    searchUnknownPkgDataLoading: false,
    searchUnknownPkgData: [],
    searchUnknownPkgDataError: false,
    restoreToStateLoading: false,
    restoreToState: [],
    restoreToStateError: false,
    oauthTokenLoading: false,
    oauthToken: {},
    oauthTokenError: false
}

export default function hdReducer(state = initialState, action){
    switch(action.type){
        case INSERT_OPERATION_LOG:
            return {
                ...state,
                insertOperationLogLoading: true,
            }
        case INSERT_OPERATION_LOG_SUCCESS:
            return {
                ...state,
                insertOperationLog: action.payload,
                insertOperationLogLoading: false
            }
        case INSERT_OPERATION_LOG_FAIL:
            return {
                ...state,
                insertOperationLogLoading: false,
                insertOperationLogError: action.payload
            }
        case SEARCH_UNKNOWN_PACKAGE_DATA:
            return {
                ...state,
                searchUnknownPkgDataLoading: true,
            }
        case SEARCH_UNKNOWN_PACKAGE_DATA_SUCCESS:
            return {
                ...state,
                searchUnknownPkgData: action.payload,
                searchUnknownPkgDataLoading: false
            }
        case SEARCH_UNKNOWN_PACKAGE_DATA_FAIL:
            return {
                ...state,
                searchUnknownPkgDataLoading: false,
                searchUnknownPkgDataError: action.payload
            }
        case RESTORE_TO_STATE:
            return {
                ...state,
                restoreToStateLoading: true
            }
        case RESTORE_TO_STATE_SUCCESS:
            return {
                ...state,
                restoreToState: action.payload,
                restoreToStateLoading: false
            }
        case RESTORE_TO_STATE_FAIL:
            return {
                ...state,
                restoreToStateLoading: false,
                restoreToStateError: action.payload
            }
        case OAUTH_TOKEN:
            return {
                ...state,
                oauthTokenLoading: true
            }
        case OAUTH_TOKEN_SUCCESS:
            return {
                ...state,
                oauthToken: action.payload,
                oauthTokenLoading: false
            }
        case OAUTH_TOKEN_FAIL:
            return {
                ...state,
                oauthTokenLoading: false,
                oauthTokenError: action.payload
            }
        default:
            return state;
    }
}